<template>
  <div class="position-relative">
    <div
      ref="actions-button"
      class="table__select-options"
      @click="toggleActions"
    >
      <i class="material-icons md-dark-blue">more_horiz</i>
    </div>
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-show="isShown"
        ref="actions-modal"
        class="table__select-options__modal active"
        :class="{'top': isTop}"
      >
        <div
          class="table__select-options__wrapper"
          @click="editTemplate"
        >
          <i class="material-icons">create</i>
          <span class="table__select-options__wrapper__text">
            Редактировать
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'TemplateActions',
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isShown: false,
    isTop: false,
  }),
  created() {
    document.addEventListener('click', this.onOutsideClickHandler);
  },
  destroyed() {
    document.removeEventListener('click', this.onOutsideClickHandler);
  },
  methods: {
    toggleActions() {
      if (this.user.interfaces.includes('UM-SVO-readonly')) {
        this.isShown = false;
      } else {
        this.isShown = !this.isShown;
      }

      // Add class 'top' if the modal is outside of the table
      this.isTop = false;

      this.$nextTick(() => {
        const modalBottom = this.$refs['actions-modal'].getBoundingClientRect().bottom;
        const tableBottom = document.querySelector('.table-wrapper').getBoundingClientRect().bottom;

        if (modalBottom > tableBottom) {
          this.isTop = true;
        }
      });
    },
    onOutsideClickHandler(evt) {
      if (!this.$refs['actions-button'].contains(evt.target) && !this.$refs['actions-modal'].contains(evt.target)) {
        this.isShown = false;
      }
    },
    editTemplate() {
      this.isShown = false;
      this.$emit('editTemplate', this.template);
    },
  },
};
</script>

<style lang="scss" scoped>
.table__select-options__modal.disabled .table__select-options__wrapper {
  opacity: 0.65;
}

.interactive.table .table__select-options__modal.top {
  bottom: 35px;
}
</style>
